// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"96a46a29c0a1cfa0eb13","627":"4600bd34ca199805cf03"}[chunkId] + ".js";
};